import en from './languages/english.js'
import es from './languages/spanish.js'
import ch from './languages/chinese.js'
import vn from './languages/vietnamese.js'

// Regexes
/* eslint-disable */
const regex = {
  email: '^([a-zA-Z0-9_\+\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]+|[0-9]+)(\]?)$',
  url: 'http[s]?://(?:[a-zA-Z]|[0-9]|[$-_@.&+]|[!*\(\),]|(?:%[0-9a-fA-F][0-9a-fA-F]))+'
}
/* eslint-enable */

const languages = [
  { key: 'en', name: 'English', icon: '/img/flags/us-square.png' },
  { key: 'es', name: 'Español', icon: '/img/flags/mexico-square.png' },
  { key: 'ch', name: '中文', icon: '/img/flags/china-square.png' },
  { key: 'vn', name: 'Tiếng Việt', icon: '/img/flags/vietnam-square.png' }
]

const LANG = {
  en: 'en',
  es: 'es',
  ch: 'ch',
  vn: 'vn'
}

// http://www.ecma-international.org/ecma-262/6.0/#sec-object-initializer
const data = {
  [LANG.en]: en,
  [LANG.es]: es,
  [LANG.ch]: ch,
  [LANG.vn]: vn
}

export default { languages, data }
